module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('img', {
    directives: [{
      name: "lazy",
      rawName: "v-lazy",
      value: (_vm.imgUrl),
      expression: "imgUrl"
    }],
    staticClass: "topbanner"
  }), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('router-link', {
    staticClass: "calculate-link",
    attrs: {
      "to": "/chosefood"
    }
  }, [_vm._v("开始计算摄入热量")])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tips"
  }, [_c('div', {
    staticClass: "tip-icon"
  }, [_vm._v("使用帮助")]), _vm._v(" "), _c('ul', {
    staticClass: "tip-detail"
  }, [_c('li', [_vm._v("1. 请选择所吃食物")]), _vm._v(" "), _c('li', [_vm._v("2. 所有食物需先选择食物类别")]), _vm._v(" "), _c('li', [_vm._v("3. 所吃食物可以选择多项")]), _vm._v(" "), _c('li', [_vm._v("4. 计算出所有食物产生的总热量")]), _vm._v(" "), _c('li', [_vm._v("5. 计算某一种运动方式所需时间")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-252b5b3a"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/index.vue
// module id = 137
// module chunks = 1